import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-speed-dots',
    templateUrl: './speed-dots.component.html',
    styleUrls: ['./speed-dots.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class SpeedDotsComponent {
    @Input() speed: number;
    constructor() { }
}
